// src/auth/AuthCallback.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    // React StrictMode 중복 실행 방어
    if (window.__AUTH_CALLBACK_DONE__) return;
    window.__AUTH_CALLBACK_DONE__ = true;

    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (!token) {
      console.error("[AuthCallback] token missing");
      navigate("/", { replace: true });
      return;
    }

    // JWT 저장
    localStorage.setItem("auth_token", token);

    // JWT payload 디코딩 → 사용자 정보 저장
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      localStorage.setItem("auth_user", JSON.stringify(payload));
      console.log("[AuthCallback] user payload", payload);
    } catch (e) {
      console.warn("[AuthCallback] payload decode failed");
    }

    console.log("[AuthCallback] login success");

    // token 파라미터 제거 + 홈 이동
    navigate("/", { replace: true });
  }, [navigate]);

  return (
    <div style={{ padding: 20 }}>
      로그인 처리 중...
    </div>
  );
}
